import styled from "styled-components";

export const BaseContainer = styled.div`
  background: #f6f6f6;
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 26px;
`;
